import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from "@angular/router";
import { CreatePickUpResponse } from '../../api/models/createPickUpResponse';
import { CreatePickUpSession } from '../../api/models/CreatePIckUpSession';
import { ProgressBarDetails } from '../../api/models/ProgressBarDetails';
import { SessionRequest } from '../../api/models/SessionRequest';
import { SessionResponse } from '../../api/models/SessionResponse';
import { A4_PLACARD_SIZE, ApiErrorCode, CONTINENTAL_REGIONS, COUNTRY_LANGUAGE, GlobalFlags, RouteURLConstants, ServiceURLConstants, UTagConstants } from '../../constants/upplm.constants';
import { ReCaptchaDirective } from '../../directive/re-captcha.directive';
import { PlacardOptionsResponse } from '../../interface/upplm.placard';
import { GetCaptchaPublicKeyRequest, GetCaptchaPublicKeyResponse } from '../../interface/upplm.review';
import { TranslateDataPipe } from '../../pipes/translation.pipe';
import { UpplmApiService } from '../../services/upplm.api.services';
import { UpsCommonService } from '../../services/upplm.common.service';
import { CreatePickUpService } from '../../services/upplm.createPickUp.service';
import { PlacardSizeService } from '../../services/upplm.placardSize.service';
import { ProgressBarService } from '../../services/upplm.progressbar.service';
import { UpplmSessionService } from '../../services/upplm.session.service';
import { UtagService } from '../../services/upplm.utag.service';
import { UpsDialogComponent } from '../commonComponent/ups-dialog/ups-dialog.component';


@Component({
    selector: 'review',
    template: require('./review.component.html'),
    providers: [PlacardSizeService]
})

export class ReviewComponent implements OnInit, AfterViewInit {
    @ViewChild('ConfirmationBox', { static: false }) ConfirmationBoxModal;
    @ViewChild('SessionErrorModal', { static: false }) SessionErrorModal;
    @ViewChild('messages', { static: false }) errorMessagesServer: UpsDialogComponent;
    public messagesErrorServer: string = '';
    sessionData: SessionResponse;
    public pbDetails: ProgressBarDetails;
    public isLoadding: boolean = false;
    public isInitialLoadding: boolean = true;
    placardInformations: PlacardOptionsResponse;
    public placardType: string;
    public placardSize: string;
    public togglePlacard: string;
    public siteKey: string;
    private _getCaptchaPublicKeyRequest: GetCaptchaPublicKeyRequest;
    private _getCaptchaPublicKeyResponse: GetCaptchaPublicKeyResponse;
    public pickupType: string;
    public recaptchaR: string = '';
    public createPickUpError: string = '';
    Errors: any[];
    public formatedPreferred: string[];
    public formatedLatest: string[];
    public showRecatpcha: boolean;
    isProcessing: boolean = false;
    public loc: string = '';
    countryCode: string = '';
    globalRegionCountry: string = 'NA';
    notificationsDetail: string[] = [];
    placardCountryCode: string = 'US';
    signin: FormGroup;
    @ViewChild(ReCaptchaDirective, { static: false })
    primarySampleComponent: ReCaptchaDirective;

    constructor(private router: Router,
        private _apiService: UpplmApiService,
        private _commonService: UpsCommonService,
        private _sessionService: UpplmSessionService,
        private _createPickUpService: CreatePickUpService,
        private _pbService: ProgressBarService,
        private _utagService: UtagService,
        private _translateData: TranslateDataPipe,
        private _placardSizeService: PlacardSizeService) {
        this.loadFormControls();
    }

    public loadFormControls(): void {
        this.signin = new FormGroup({
            captcha: new FormControl()
        });
    }

    public test(event: any) {
        const testValKey: any = this.primarySampleComponent.valueKey;
    }

    ngOnInit() {
        this.isInitialLoadding = true;
        this.countryCode = this._commonService.locale_country;
        this.placardCountryCode = this._sessionService.sessionData.locationDetails.countryKey;
        this.globalRegionCountry = this._commonService.getRegionCountry(this.countryCode);
        this.loc = this._commonService.locale_country.toUpperCase();
        this._utagService.utagForStartOfTheEvent(UTagConstants.UPPLM_REVIEW_START, UTagConstants.UPPLM_REVIEW_START_SCREEN);
        this.pbDetails = this._pbService.pb;
        this.getPlacardOptions();
        if (GlobalFlags.DISABLE_RECAPTCHA_PART === 'true') {
            this.getCaptchaPublicKey();
        }
        this.showRecatpcha = (GlobalFlags.DISABLE_RECAPTCHA_PART == 'true') ? true : false;
        this.sessionData = this._sessionService.sessionData;
        this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest(false)).subscribe((response: SessionResponse) => {
            if (response.commonResponse.isSuccess && response.key && response.locationDetails != null) {
                this.sessionData = response;
                this._sessionService.mapSessionResponse(response);
                if (this.sessionData.locationDetails.city == null) {
                    this.goToLocation();
                    return;
                }
                this.notificationsDetail = this.setNotifications();
                this.placardInformation();
                this.getSchedule();
                this.getPlacardSize();
                this.isInitialLoadding = false;
            }
            else {
                this.SessionErrorModal.open();
            }
        });
    }

    spliceNotifications() {
        if (!this.sessionData.contactDetails.makePrimaryContact && this.sessionData.notificationDetails.aditionalEmails.length == 4) {
            this.sessionData.notificationDetails.aditionalEmails.splice(3, 1);
        }
    }

    setNotifications(): string[] {
        let notifications: string[] = [];
        this.spliceNotifications();
        notifications.push(`${this.sessionData.contactDetails.email} - ${this.getPosEmailValue(this.placardCountryCode)}`)
        if (!this.sessionData.contactDetails.makePrimaryContact) {
            notifications.push(`${this.sessionData.contactDetails.primaryEmail} - ${this.getPosEmailValue(this.placardCountryCode)}`)
        }
        if (this.sessionData.notificationDetails.aditionalEmails) {
            this.sessionData.notificationDetails.aditionalEmails.forEach(email => {
                notifications.push(`${email.email} - ${this.getPosEmailValue(this.placardCountryCode)}`);
            }, this);
        }
        return notifications;
    }

    getPosEmailValue(emailLocale: string): string {
        const data = COUNTRY_LANGUAGE.find(x => x.key === emailLocale);
        return `${data.key} ${this._translateData.transform(data.language)}`;
    }

    public redirectTo(url: string) {
        this.router.navigate(['/' + url])
    }

    getSchedule() {
        this.formatedPreferred = [];
        this.formatedLatest = [];
        this.sessionData.pickupDetails.allSchedule.forEach(item => {
            if (item.latestSelected !== '-1' || item.preferredSelected !== '-1') {
                this.formatedPreferred.push(this.getSchedulesByGlobalRegion(item.preferredSelected));
                this.formatedLatest.push(this.getSchedulesByGlobalRegion(item.latestSelected));
            }
        }, this);
    }

    getSchedulesByGlobalRegion(schedule: string): string {
        // As this only shows data, should be presented in the locale language format
        const region = this._commonService.getRegionCountry(this.countryCode);
        switch (region) {
            case CONTINENTAL_REGIONS.EMEA:
                return schedule;
            case CONTINENTAL_REGIONS.NA:
                return this._commonService.formatAMPM(schedule);
            default:
                return schedule;
        }
    }

    goToLocation() {
        this._pbService.pb = new ProgressBarDetails();
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
    }

    placardInformation() {
        this.togglePlacard = (this.sessionData.placardDetails.togglePlacard) ? this._translateData.transform('upplm.common.yes') : this._translateData.transform('upplm.common.no');

        // Setting the Placard Type
        this.placardInformations.placardType.forEach(item => {
            if (item.key === this.sessionData.placardDetails.placardTypekey) {
                this.placardType = this.sessionData.placardDetails.placardTypekey === "01" ? this._translateData.transform("upplm.placarddetails.labspecimen").toUpperCase() : this._translateData.transform("upplm.placarddetails.nonlab").toUpperCase();
            }
        })


    }

    getPlacardSize() {
        const region = this._commonService.getRegionCountry(this.placardCountryCode);
        // Setting the Placard Size
        this.placardInformations.placardSize.forEach(item => {
            if (item.key === this.sessionData.placardDetails.placardSizeKey) {
                switch (region) {
                    case CONTINENTAL_REGIONS.NA:
                        this.placardSize = item.value;
                        break;
                    case CONTINENTAL_REGIONS.EMEA:
                        this.placardSize = A4_PLACARD_SIZE;
                        break;
                }
            }
        });
    }

    createSessionRequest(update: boolean): SessionRequest {
        let request: SessionRequest = new SessionRequest();
        request.key = this.sessionData.key;
        if (update) {
            this._pbService.pb.showStatusBar = true;
            request.notificationDetails = this.sessionData.notificationDetails;
            request.notificationDetails.showStatusBar = true; // Add
        }
        else {
            request.notificationDetails = this.sessionData.notificationDetails;
        }
        request.locationDetails = this.sessionData.locationDetails;
        request.temporaryLocation = this.sessionData.temporaryLocation;
        request.contactDetails = this.sessionData.contactDetails;
        request.placardDetails = this.sessionData.placardDetails;
        request.pickupDetails = this.sessionData.pickupDetails;

        request.createPickUp = this.sessionData.createPickUp;
        request.lastTimeSessionReqired = new Date().toString();
        return request;
    }

    ngAfterViewInit() {
        this.ConfirmationBoxModal.setProperties({
            title: this._translateData.transform('upplm.common.sessiontimedouttitle')
        });
        this.SessionErrorModal.setProperties({
            title: this._translateData.transform('upplm.common.serviceerror')
        });
    }

    nextPageRecaptchaV3(){
        this.primarySampleComponent.onSuccess().then(
                response=>{
                    if(response){
                        this.recaptchaR="Success" ;
                        this.showRecatpcha=false;
                    }
                    else{
                        this.recaptchaR=null;
                    }
                    this.nextPage();
            });
    }

    nextPage() {
        if (!this._sessionService.isValidSession()) {
            this._pbService.pb = new ProgressBarDetails();
            this.ConfirmationBoxModal.open();
        }
        else {
            this.displayErrors();
            if (this.Errors.length == 0) {
                if (!this.isLoadding) {
                    this.isLoadding = true;
                    this.createPickUpResponse();
                }
            }
        }
    }

    createPickUpResponse() {
        this._createPickUpService.createPickUp(this._commonService.createURL(ServiceURLConstants.CREATE_PICKUP, ApiErrorCode.CREATE_PICKUP), this.createSessionRequest(false)).subscribe((resp: CreatePickUpResponse) => {
            let createPickUpResponse = resp;
            if (createPickUpResponse.creationResult === 'true') {
                this.sessionData.createPickUp = new CreatePickUpSession();
                this.sessionData.createPickUp.creationResult = createPickUpResponse.creationResult;
                this.sessionData.createPickUp.documentUrl = createPickUpResponse.documentUrl;
                this.sessionData.createPickUp.placardId = createPickUpResponse.placardId;
                this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest(false)).subscribe((response: SessionResponse) => {
                    if (response.commonResponse.isSuccess && response.key) {
                        this.sessionData = response;
                        this._sessionService.mapSessionResponse(response);
                        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_CONFIRMATION_ROUTE);
                    }
                });
            }
            else {
                this.showErrorMessage(resp.errors[0].message);
                this.isLoadding = false;
                this.openModel();
            }
        });
    }

    showErrorMessage(respErrMessage: string) {
        if (respErrMessage === 'GENERIC_ERROR_MESSAGE') {
            this.createPickUpError = this._translateData.transform('upplm.common.serviceerror');
            this.messagesErrorServer = this._translateData.transform('upplm.common.serviceerror');
        }
        if (respErrMessage === 'CENTER_NO_DEPLOYED') {
            this.createPickUpError = this._translateData.transform('upplm.review.centernotdeployed');
            this.messagesErrorServer = this._translateData.transform('upplm.review.centernotdeployed');
        }
    }

    backPage() {
        if (!this._sessionService.isValidSession()) {
            this._pbService.pb = new ProgressBarDetails();
            this.ConfirmationBoxModal.open();
        }
        else {
            this._pbService.pb = new ProgressBarDetails();
            this._pbService.pb.locationPB = "true";
            this._pbService.pb.contactPB = "true";
            this._pbService.pb.placardPB = "true";
            this._pbService.pb.pickupPB = "true";
            this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_NOTIFICATION_DETAILS_ROUTE);
        }
    }

    cancelGoDashboardPage() {
        this._sessionService.cleanSessionData(this._commonService.createURL(ServiceURLConstants.CLEAN_SESSION, ApiErrorCode.CLEAN_SESSION)).subscribe((response: any) => {
            this._pbService.pb = new ProgressBarDetails();
            this._pbService.pb.showStatusBar = false;
            this._sessionService.mapSessionResponse(response);
            this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
        });
    }

    validateSessionAndNavigate(target: string) {
        if (!this._sessionService.isValidSession()) {
            this._pbService.pb = new ProgressBarDetails();
            this.ConfirmationBoxModal.open();
        }
        else {
            this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest(true)).subscribe((response: SessionResponse) => {
                if (response.commonResponse.isSuccess) {
                    this._sessionService.mapSessionResponse(response);
                    this.router.navigateByUrl(target);
                }
            });
        }
    }

    displayErrors() {
        this.Errors = [];
        if (GlobalFlags.DISABLE_RECAPTCHA_PART === 'true') {
            if (this.recaptchaR == null || this.recaptchaR == '') {
                this.Errors = this.Errors.concat(this.addError('reCaptcha ' + this._translateData.transform("upplm.common.isrequired"), 'general'));
            }
        }
    }

    addError(field: string, condition: string): any {
        return [{
            "id": "string",
            "displayText": field,
            "type": condition,
            "fieldName": "Name",
            "fieldError": "Name error",
            "fieldErrorDescription": "field Error"
        }];
    }

    getPlacardOptions() {
        this._apiService.PostServiceAPI(this._commonService.createURL(ServiceURLConstants.GET_PLACARD_OPTIONS, ApiErrorCode.GET_PLACARD_OPTIONS), null).subscribe((response: PlacardOptionsResponse) => {
            this.placardInformations = response;
        });
    }

    getCaptchaPublicKey() {
        this._getCaptchaPublicKeyRequest = new GetCaptchaPublicKeyRequest();
        this._apiService.PostServiceAPI(this._commonService.createURL(ServiceURLConstants.GET_CAPTCHA_PUBLIC_KEY, ApiErrorCode.GET_CAPTCHA_PUBLIC_KEY), this._getCaptchaPublicKeyRequest).subscribe((response: GetCaptchaPublicKeyResponse) => {
            this._getCaptchaPublicKeyResponse = response;
        });
    }

    public openModel() {
        this.errorMessagesServer.open();
    }

    public closeModal() {
        this.errorMessagesServer.close();
    }
}